module.exports = __webpack_public_path__ + "media/images/single50-45cb28c8657d7787a09753ec619baab6.jpg";